// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2HAO9","col":"CardReaderDesc_col__1dXxd","label":"CardReaderDesc_label__32yDR"};